// Unprotected routes
export const ROOT = '/';
export const LOGIN = '/login';

// Protected routes
export const DEVICES = '/devices';
export const DEVICES_DETAILS = '/devices/:id';
export const SOFTWARES = '/softwares';
export const SOFTWARE_DETAILS = '/softwares/:id';
export const SOFTWARE_UPLOAD = '/softwares/upload';
export const ROLLOUTS = '/rollouts';
export const ROLLOUT_DETAILS = '/rollouts/:id';
export const ROLLOUT_GROUP_DETAILS = '/rollouts/:rolloutId/groups/:groupId';
export const ROLLOUTS_CREATE = '/softwares/:id/createRollout';
export const LWM2M = '/lwm2m';
export const LWM2M_DETAILS = '/lwm2m/:id';
export const HUSQIOTBUS = '/husqiotbus';
export const HUSQIOTBUS_SUBSCRIPTIONS = '/husqiotbus/subscription';
export const HUSQIOTBUS_SUBSCRIPTION_DETAILS = '/husqiotbus/subscription/:id';
export const RELEASES = '/releases';
export const RELEASE_DETAILS = '/releases/:id';
